<h1 class="title">Your Shipping Address</h1>
<p class="instructions">Where would you like your workbook sent? Estimated arrival is in 3-5 weeks.</p>
<form [formGroup]="workbookAddressForm" (ngSubmit)="onSubmit(workbookAddressForm.value)">
  <div class="form-field-group">
    <label class="label">
      <span class="form-label">First Name</span>
      <input
        class="form-input name"
        type="text"
        placeholder="Enter your first name"
        required
        formControlName="firstName" />
    </label>
    <label class="label">
      <span class="form-label">Last Name</span>
      <input
        class="form-input name"
        type="text"
        placeholder="Enter your last name"
        required
        formControlName="lastName" />
    </label>
  </div>
  <div class="form-field-group">
    <label class="label">
      <span class="form-label">Street Address</span>
      <input
        class="form-input address"
        type="text"
        placeholder="Enter a street address"
        required
        formControlName="streetAddress" />
    </label>
    <label class="label">
      <span class="form-label">Apt / Suite / Other</span>
      <input class="form-input apt" type="text" formControlName="apt" placeholder="Optional" />
    </label>
  </div>
  <div class="form-field-group">
    <label class="label">
      <span class="form-label">City</span>
      <input class="form-input city" type="text" required formControlName="city" placeholder="Enter a city" />
    </label>
    <label class="label">
      <span class="form-label">State</span>
      <select class="form-input state" required id="state-address-form" formControlName="state">
        <option value="" selected disabled>State</option>
        <option *ngFor="let state of constants.states" [value]="state">{{ state }}</option>
      </select>
      <svg-icon class="dropdown-arrow" src="/assets/icons/chevron-right-nocircle.svg"></svg-icon>
    </label>
    <label class="label">
      <span class="form-label">ZIP Code</span>
      <input
        class="form-input zip"
        type="text"
        required
        maxLength="5"
        formControlName="postalCode"
        placeholder="Enter a ZIP code" />
    </label>
  </div>
  <button class="button button-pill button-save" type="submit" [disabled]="workbookAddressForm.invalid">Save</button>
  <a class="button-cancel" routerLink="/welcome/workbook/review">Cancel</a>
</form>
